import { Reveal, Overline } from "@/components/site/Reveal";
import { useLanguage } from "@/context/LanguageContext";
import { IMAGES } from "@/i18n/assets";

export function Tartan() {
  const { t } = useLanguage();

  return (
    <section id="tartan" data-testid="tartan-section" className="relative overflow-hidden bg-clan-surface py-28 lg:py-40">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-2 lg:gap-24 lg:px-10">
        <Reveal y={40}>
          <div className="relative">
            <div className="tartan-weave aspect-square w-full rounded-lg border border-clan-ink/10 shadow-2xl" />
            <div className="absolute -bottom-6 -right-6 hidden h-40 w-40 overflow-hidden rounded-lg border border-clan-ink/15 shadow-2xl sm:block">
              <img src={IMAGES.tartan} alt="Tartan cloth" className="h-full w-full object-cover" />
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <Overline>{t.tartan.overline}</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif text-4xl font-light leading-[1.05] tracking-tight text-clan-ink sm:text-5xl lg:text-6xl pearl">
              {t.tartan.title}
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-md text-base leading-relaxed text-clan-muted">{t.tartan.body}</p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-10 border-l-2 border-clan-accent pl-6">
              <p className="font-serif text-3xl italic text-clan-accent lg:text-4xl">{t.tartan.motto}</p>
              <p className="mt-2 font-mono text-xs uppercase tracking-[0.25em] text-clan-muted">
                {t.tartan.mottoTranslation}
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
